import htmlComponent from "htmlcomponent";

export default function (dom, opts) {
	let options = {

		hideCls: 'filter-out',
		fileDataSel: '[data-values]',
		fileDataTargetSel: '[data-values][data-filter-target]',
		filterInputSel: '.simple-filter__single-checkbox',
		downloadFileSel: '.downloads__grid-single',
		resultSel: '.result-count',
		...opts
	};

	const body = document.body;
	const button = body.querySelector('[data-result]');

	const filterSingle = Array.from(body.querySelectorAll(options.fileDataSel));
	const filterTargets = Array.from(body.querySelectorAll(options.fileDataTargetSel));
	const allFilters = Array.from(dom.querySelectorAll(options.filterInputSel));
	const files = Array.from(body.querySelectorAll(options.downloadFileSel));
	const showCount = Array.from(dom.querySelectorAll(options.resultSel));

	let filterValue = "";

	function init() {
		allFilters.forEach( (filter, index) => {
			const targets = filterTargets.filter(target => target.dataset.values.split(/,\s?/).includes(filter.value) && target.dataset.filterTarget === 'download');
			showCount[index].innerHTML = targets.length;
		});
		button.addEventListener('click', () => {
			const selected = allFilters.filter(filter => filter.checked).map(filter => filter.value);
			applyFilters(selected);
		})
	}

	function resetFilter() {
		filterTargets.forEach(target => {
			target.classList.remove(options.hideCls);
		});
		files.forEach(file => {
			file.classList.remove(options.hideCls);
		});
	}

	function applyFilters(values) {
		if (!values.length) {
			resetFilter();
			return;
		}

		filterTargets.forEach(target => {
			const targetValues = target.dataset.values.split(/,\s*/);
			const active = values.some(value => targetValues.includes(value));
			target.classList.toggle(options.hideCls, !active);
		});

		files.forEach(file => {
			const visibleChild = file.querySelector(`${options.fileDataTargetSel}:not(.${options.hideCls})`);
			file.classList.toggle(options.hideCls, !visibleChild);
		});
	}

	init()

}
